// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Link from "../Link.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import * as UnitSynergiesTable from "./UnitSynergiesTable.bs.js";
import * as TraitSynergiesTable from "./TraitSynergiesTable.bs.js";
import * as AugmentSynergiesTable from "./AugmentSynergiesTable.bs.js";
import OpenInFull from "@mui/icons-material/OpenInFull";

var baseCols = [
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Play rate");
        }), undefined, (function (v, param, param$1) {
          return Global.formatPct(undefined, Global.f(v.count) / Global.f(param[0])) + "%";
        }), undefined, (function (v, param, param$1) {
          return T.humanReadableCount(v.count) + " games";
        }), undefined, (function (v, param, param$1) {
          return v.count;
        }), undefined, 106, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Adj. Place");
        }), undefined, (function (v, param, param$1) {
          if (Belt_Option.isNone(param[3])) {
            return Global.toFixed(undefined, v.adjPlace);
          } else {
            return "-";
          }
        }), undefined, undefined, Caml_option.some(React.createElement("div", {
                className: "leading-tight"
              }, "Item stats in TFT are subject to heavy statistical biases. Adj. Place does extra processing on item placement data to reduce the impact of those biases.")), (function (v, param, param$1) {
          return v.adjPlace;
        }), undefined, 106, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Place");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixed(undefined, v.place);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.place;
        }), undefined, 76, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Top 4") + " %";
        }), undefined, (function (v, param, param$1) {
          return Global.formatPct3(v.top4);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.top4;
        }), undefined, 96, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Win") + " %";
        }), undefined, (function (v, param, param$1) {
          return Global.formatPct3(v.won);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.won;
        }), undefined, 80, undefined, undefined)
];

var cols = Belt_Array.concatMany([
      [StatsTable2.col(undefined, undefined, (function (param, param$1) {
                return param$1.t("Items");
              }), undefined, (function (v, param, param$1) {
                var aperture = param$1.aperture;
                return React.createElement("div", {
                            className: "flex gap-[6px]"
                          }, Belt_Array.mapWithIndex(v.items, (function (idx, itemId) {
                                  return React.createElement(Link.make, {
                                              route: {
                                                TAG: /* Stats */0,
                                                _0: {
                                                  TAG: /* Item */6,
                                                  id: itemId,
                                                  aperture: aperture
                                                }
                                              },
                                              children: React.createElement(ItemTooltip.make, {
                                                    itemId: itemId,
                                                    children: React.createElement(ItemImage.make, {
                                                          itemId: itemId,
                                                          size: 28,
                                                          rounded: "rounded"
                                                        })
                                                  }),
                                              key: String(idx)
                                            });
                                })));
              }), undefined, undefined, undefined, undefined, undefined, 92, undefined, undefined)],
      baseCols,
      [StatsTable2.col(undefined, undefined, (function (param, param$1) {
                return param$1.t("Synergies");
              }), "pl-6", (function (v, param, param$1) {
                var onExpand = param[2];
                return React.createElement("div", {
                            className: "flex items-center gap-1"
                          }, Belt_Array.map(v.synergies, (function (itemId) {
                                  return React.createElement(ItemTooltip.make, {
                                              itemId: itemId,
                                              children: React.createElement(ItemImage.make, {
                                                    itemId: itemId,
                                                    size: 24,
                                                    rounded: "rounded"
                                                  }),
                                              key: itemId
                                            });
                                })), v.synergies.length === 0 ? null : React.createElement("div", {
                                  className: "ml-auto cursor-pointer ml-2",
                                  onClick: (function (param) {
                                      return Curry._1(onExpand, v.items);
                                    })
                                }, React.createElement(OpenInFull, {
                                      fontSize: "small"
                                    })));
              }), "pl-6", undefined, undefined, undefined, undefined, 136, undefined, undefined)]
    ]);

var pairCols = Belt_Array.concatMany([
      [StatsTable2.col(undefined, undefined, (function (v, param) {
                return param.t("Items");
              }), undefined, (function (v, param, param$1) {
                return React.createElement("div", {
                            className: "flex gap-[6px]"
                          }, Belt_Array.mapWithIndex(v.items, (function (idx, itemId) {
                                  return React.createElement(ItemTooltip.make, {
                                              itemId: itemId,
                                              children: React.createElement(ItemImage.make, {
                                                    itemId: itemId,
                                                    size: 28,
                                                    rounded: "rounded"
                                                  }),
                                              key: String(idx)
                                            });
                                })));
              }), undefined, undefined, undefined, undefined, undefined, 92, undefined, undefined)],
      baseCols,
      [StatsTable2.col(undefined, undefined, (function (param, param$1) {
                return param$1.t("Synergies");
              }), "pl-6", (function (v, param, param$1) {
                var onExpand = param[2];
                return React.createElement("div", {
                            className: "flex items-center gap-1"
                          }, Belt_Array.map(v.synergies, (function (itemId) {
                                  return React.createElement(ItemTooltip.make, {
                                              itemId: itemId,
                                              children: React.createElement(ItemImage.make, {
                                                    itemId: itemId,
                                                    size: 24,
                                                    rounded: "rounded"
                                                  }),
                                              key: itemId
                                            });
                                })), v.synergies.length === 0 ? null : React.createElement("div", {
                                  className: "ml-auto cursor-pointer ml-2",
                                  onClick: (function (param) {
                                      return Curry._1(onExpand, v.items);
                                    })
                                }, React.createElement(OpenInFull, {
                                      fontSize: "small"
                                    })));
              }), "pl-6", undefined, undefined, undefined, undefined, 136, undefined, undefined)]
    ]);

var tripleCols = Belt_Array.concatMany([
      [StatsTable2.col(undefined, undefined, (function (param, param$1) {
                return param$1.t("Items");
              }), undefined, (function (v, param, param$1) {
                return React.createElement("div", {
                            className: "flex gap-[6px]"
                          }, Belt_Array.mapWithIndex(v.items, (function (idx, itemId) {
                                  return React.createElement(ItemTooltip.make, {
                                              itemId: itemId,
                                              children: React.createElement(ItemImage.make, {
                                                    itemId: itemId,
                                                    size: 28,
                                                    rounded: "rounded"
                                                  }),
                                              key: String(idx)
                                            });
                                })));
              }), undefined, undefined, undefined, undefined, undefined, 126, undefined, undefined)],
      baseCols
    ]);

function UnitItemsTable$ItemsTable(Props) {
  var unitStats = Props.unitStats;
  var expandedItems = Props.expandedItems;
  var tab = Props.tab;
  var inContext = Props.inContext;
  var onExpand = Props.onExpand;
  var starLevel = Props.starLevel;
  var scrollRef = Props.scrollRef;
  var baseAdjDelta = unitStats.baseAdjDelta;
  var dataSingles = React.useMemo((function () {
          return Belt_Array.map(unitStats.items, (function (d) {
                        return {
                                items: [d.items],
                                count: d.count,
                                adjPlace: baseAdjDelta + unitStats.base.place + d.adjDelta * (1 - Global.f(d.count) / Global.f(unitStats.base.count)),
                                top4: d.top4,
                                won: d.won,
                                place: d.place,
                                synergies: Belt_Array.slice(Belt_Array.map(Belt_SortArray.stableSortBy(Belt_Array.keep(unitStats.itemPairs, (function (d2) {
                                                    return d2.items.includes(d.items);
                                                  })), (function (d1, d2) {
                                                return Caml.caml_float_compare(d2.adjDelta, d1.adjDelta);
                                              })), (function (d2) {
                                            return Belt_Option.getWithDefault(Caml_option.undefined_to_opt(d2.items.find(function (i) {
                                                                return i !== d.items;
                                                              })), Belt_Array.getExn(d2.items, 0));
                                          })), 0, 3)
                              };
                      }));
        }), [unitStats]);
  var dataPairs = React.useMemo((function () {
          return Belt_Array.map(Belt_Array.keep(Belt_SortArray.stableSortBy(unitStats.itemPairs, (function (d1, d2) {
                                return Caml.caml_int_compare(d2.count, d1.count);
                              })), (function (d) {
                            if (expandedItems.length === 0) {
                              return true;
                            } else {
                              return Belt_Array.every(expandedItems, (function (i) {
                                            return d.items.includes(i);
                                          }));
                            }
                          })), (function (d) {
                        return {
                                items: d.items,
                                count: d.count,
                                adjPlace: baseAdjDelta + unitStats.base.place + d.adjDelta * (1 - Global.f(d.count) / Global.f(unitStats.base.count)),
                                top4: d.top4,
                                won: d.won,
                                place: d.place,
                                synergies: Belt_Array.slice(Belt_Array.map(Belt_Array.keep(Belt_Array.map(Belt_SortArray.stableSortBy(unitStats.itemTrios, (function (d1, d2) {
                                                        return Caml.caml_float_compare(d2.adjDelta, d1.adjDelta);
                                                      })), (function (d2) {
                                                    return T.subtractArr(d2.items, d.items);
                                                  })), (function (is) {
                                                return is.length === 1;
                                              })), (function (is) {
                                            return Belt_Array.getExn(is, 0);
                                          })), 0, 3)
                              };
                      }));
        }), [
        unitStats,
        expandedItems
      ]);
  var dataTriples = React.useMemo((function () {
          return Belt_Array.map(Belt_Array.keep(Belt_SortArray.stableSortBy(unitStats.itemTrios, (function (d1, d2) {
                                return Caml.caml_int_compare(d2.count, d1.count);
                              })), (function (d) {
                            if (expandedItems.length === 0) {
                              return true;
                            } else {
                              return Belt_Array.every(expandedItems, (function (i) {
                                            return d.items.includes(i);
                                          }));
                            }
                          })), (function (d) {
                        return {
                                items: d.items,
                                count: d.count,
                                adjPlace: baseAdjDelta + unitStats.base.place + d.adjDelta * (1 - Global.f(d.count) / Global.f(unitStats.base.count)),
                                top4: d.top4,
                                won: d.won,
                                place: d.place,
                                synergies: []
                              };
                      }));
        }), [
        unitStats,
        expandedItems
      ]);
  var context = React.useMemo((function () {
          return [
                  unitStats.base.count,
                  unitStats.base.place,
                  onExpand,
                  starLevel
                ];
        }), [
        unitStats,
        onExpand,
        starLevel
      ]);
  var keyFn = React.useCallback((function (d) {
          return d.items.join("");
        }), []);
  var tmp;
  switch (tab) {
    case /* Singles */0 :
        tmp = cols;
        break;
    case /* Pairs */1 :
        tmp = pairCols;
        break;
    case /* Triples */2 :
        tmp = tripleCols;
        break;
    case /* Augments */3 :
    case /* Units */4 :
    case /* Traits */5 :
        tmp = [];
        break;
    
  }
  var tmp$1;
  switch (tab) {
    case /* Singles */0 :
        tmp$1 = dataSingles;
        break;
    case /* Pairs */1 :
        tmp$1 = dataPairs;
        break;
    case /* Triples */2 :
        tmp$1 = dataTriples;
        break;
    case /* Augments */3 :
    case /* Units */4 :
    case /* Traits */5 :
        tmp$1 = [];
        break;
    
  }
  var tmp$2 = {
    cols: tmp,
    data: tmp$1,
    context: context,
    keyFn: keyFn,
    stickyColCount: 1
  };
  var tmp$3 = inContext ? "t52" : undefined;
  if (tmp$3 !== undefined) {
    tmp$2.top = Caml_option.valFromOption(tmp$3);
  }
  var tmp$4 = Belt_Option.map(scrollRef, (function (el) {
          return [
                  el,
                  200
                ];
        }));
  if (tmp$4 !== undefined) {
    tmp$2.scrollEl = Caml_option.valFromOption(tmp$4);
  }
  return React.createElement(StatsTable2.make, tmp$2);
}

var ItemsTable = {
  baseCols: baseCols,
  cols: cols,
  pairCols: pairCols,
  tripleCols: tripleCols,
  make: UnitItemsTable$ItemsTable
};

function UnitItemsTable(Props) {
  var inContext = Props.inContext;
  var unitStats = Props.unitStats;
  var starLevel = Props.starLevel;
  var scrollRef = Props.scrollRef;
  var match = React.useState(function () {
        return /* Singles */0;
      });
  var setTab = match[1];
  var match$1 = React.useState(function () {
        return [];
      });
  var setExpandedItems = match$1[1];
  var expandedItems = match$1[0];
  var t = Translation.useT(/* Common */0);
  var onExpand = React.useCallback((function (items) {
          return Curry._1(setExpandedItems, (function (param) {
                        return items;
                      }));
        }), []);
  var match$2 = expandedItems.length;
  var tab = match$2 !== 1 ? (
      match$2 !== 2 ? match[0] : /* Triples */2
    ) : /* Pairs */1;
  var setTab$1 = React.useCallback((function (tab) {
          Curry._1(setTab, (function (param) {
                  return tab;
                }));
          return Curry._1(setExpandedItems, (function (param) {
                        return [];
                      }));
        }), []);
  var totCount = unitStats.base.count;
  var tmp;
  var exit = 0;
  switch (tab) {
    case /* Singles */0 :
    case /* Pairs */1 :
    case /* Triples */2 :
        exit = 1;
        break;
    case /* Augments */3 :
        var tmp$1 = {
          augments: unitStats.augments,
          aug1s: unitStats.aug1s,
          aug2s: unitStats.aug2s,
          aug3s: unitStats.aug3s,
          totCount: totCount,
          inContext: inContext
        };
        if (scrollRef !== undefined) {
          tmp$1.scrollRef = Caml_option.valFromOption(scrollRef);
        }
        tmp = React.createElement(AugmentSynergiesTable.make, tmp$1);
        break;
    case /* Units */4 :
        var tmp$2 = {
          units: unitStats.units,
          totCount: totCount,
          inContext: inContext
        };
        if (scrollRef !== undefined) {
          tmp$2.scrollRef = Caml_option.valFromOption(scrollRef);
        }
        tmp = React.createElement(UnitSynergiesTable.make, tmp$2);
        break;
    case /* Traits */5 :
        var tmp$3 = {
          traits: unitStats.traits,
          totCount: totCount,
          inContext: inContext
        };
        if (scrollRef !== undefined) {
          tmp$3.scrollRef = Caml_option.valFromOption(scrollRef);
        }
        tmp = React.createElement(TraitSynergiesTable.make, tmp$3);
        break;
    
  }
  if (exit === 1) {
    var tmp$4 = {
      unitStats: unitStats,
      expandedItems: expandedItems,
      tab: tab,
      inContext: inContext,
      onExpand: onExpand,
      starLevel: starLevel
    };
    if (scrollRef !== undefined) {
      tmp$4.scrollRef = Caml_option.valFromOption(scrollRef);
    }
    tmp = React.createElement(UnitItemsTable$ItemsTable, tmp$4);
  }
  return React.createElement(ContentSection.make, {
              className: "px-0 py-0",
              children: null
            }, React.createElement("div", {
                  className: "flex justify-between pt-2 max-w-[100vw]"
                }, React.createElement(Tabs, {
                      variant: "scrollable",
                      children: null,
                      value: tab,
                      onChange: (function (param, t) {
                          return Curry._1(setTab$1, t);
                        })
                    }, React.createElement(Tab, {
                          label: t("Items"),
                          value: /* Singles */0
                        }), React.createElement(Tab, {
                          label: t("Item Pairs"),
                          value: /* Pairs */1
                        }), React.createElement(Tab, {
                          label: t("Item Trios"),
                          value: /* Triples */2
                        }), React.createElement(Tab, {
                          label: t("Units"),
                          value: /* Units */4
                        }), React.createElement(Tab, {
                          label: t("Traits"),
                          value: /* Traits */5
                        })), React.createElement("div", {
                      className: "pr-2 flex items-center"
                    }, Belt_Array.mapWithIndex(expandedItems, (function (idx, itemId) {
                            return React.createElement("div", {
                                        key: String(idx),
                                        className: "pr-1"
                                      }, React.createElement(ItemImage.make, {
                                            itemId: itemId,
                                            size: 24,
                                            rounded: "rounded"
                                          }));
                          })), expandedItems.length !== 0 ? React.createElement("div", {
                            className: "pl-1"
                          }, "Synergies") : null)), tmp);
}

var make = UnitItemsTable;

export {
  ItemsTable ,
  make ,
  
}
/* baseCols Not a pure module */
